
// video_bg
// ------------------------------------

function video_bg(el) {
  const video_src_el = el.querySelectorAll('[data-js-video-bg-src]')[0];
  const video        = el.querySelector('video');
  const video_src    = video_src_el.getAttribute('data-js-video-bg-src');
  const active_class = el.getAttribute('data-js-video-bg-active-class');

  function enable() {
    el.classList.add(active_class);
    video_src_el.setAttribute('src', video_src);
    video.play();
  }

  if (!window.isMobileDevice()) {
    enable();
  }
}


// init_all
// ------------------------------------

function init_all() {
  const items = Array.from(document.querySelectorAll('[data-js-video-bg]'));
  items.forEach(video_bg);
}
init_all();

